import { Outlet, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useGlobalStore } from "@/GlobalStore";
import { Button } from "@/components/ui/button";
import { useKeycloak } from "@react-keycloak/web";

interface PermissionGuardProps {
  requiredPermission?: string;
  keycloakRealm?: string;
}

const PermissionGuard = ({ requiredPermission, keycloakRealm }: PermissionGuardProps) => {
  const permission = useGlobalStore((state) => state.permission);
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const hasRealmAccess = keycloakRealm
    ? (keycloak?.hasRealmRole(keycloakRealm) ?? false)
    : true;
  const hasPermission = requiredPermission
    ? permission[requiredPermission] === true
    : true;

  if (hasPermission && hasRealmAccess) return <Outlet />;

  return (
    <div className="flex flex-col items-center justify-center h-full w-[40%] m-auto">
      <div className="flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mb-6">
        <Lock size={24} className="text-gray-500" />
      </div>
      <div className="text-center font-medium text-[18px] leading-[100%] tracking-[0%] text-brand-primary-new">
        Access Restricted
      </div>
      <p className="text-center font-normal text-[16px] leading-[120%] tracking-[0%] text-[#617390] mt-4">
        You don't have permission to access this feature. Please contact your
        administrator to request access.
      </p>
      <Button
        className="h-8 bg-[#FF4500] hover:bg-[#FF4500CC] mt-6"
        onClick={() => navigate("/")}
      >
        <span className="font-medium text-[12px] leading-[19.16px] tracking-[0.02em] text-white">
          Go Back
        </span>
      </Button>
    </div>
  );
};

export default PermissionGuard;
